import { getLocale } from "../runtime";

const sv_recommendedforyou = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rekommenderat för dig`
};

const recommendedforyou = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_recommendedforyou(inputs)
	return "recommendedForYou";
};

export { recommendedforyou as "recommendedForYou" };